import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

const Notifications = React.lazy(() => import('./index'));
const NotificationTable = React.lazy(() => import('./notificationTable'));
const Notification = React.lazy(() => import('./notification'));
const NotificationDetail = React.lazy(() => import('./notificationDetail'));
const SendNotification = React.lazy(() => import('./sendNotification'));

export const useNotificationRoutes = () => {

    return (
        <Route path="notifications" element={<Suspense fallback={<div>منتظر باشید...</div>}><Notifications /></Suspense>} >
            <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><NotificationTable /></Suspense>} />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><SendNotification /></Suspense>} />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Notification /></Suspense>} >
                <Route index element={<Suspense fallback={<div>منتظر باشید...</div>}><NotificationDetail /></Suspense>} />
            </Route>
        </Route>
    )
}